import { SettingsCustomisationDTO, SettingsNavigationItemsDTO } from '@typings';

import { showroomApi } from './api';

export const fetchSettings = async () => showroomApi.QUERY_GET('/settings')({});

export const editNavigationItems = async (data: SettingsNavigationItemsDTO) => showroomApi.QUERY_POST('/settings')({ data });

export const editCustomisationSettings = async (data: SettingsCustomisationDTO) => showroomApi.QUERY_POST('/settings')({ data });
